import React from "react";
import { NavLink } from "react-router-dom";
import Table from "react-bootstrap/Table";
import {
  FaPencilAlt,
  FaPause,
  FaPlay,
  FaList,
  FaEnvelope,
} from "react-icons/fa";
import { reactLocalStorage } from "reactjs-localstorage";

import UserAPI from "../../../api/UserAPI";
import Display from "../../../util/Display";
import Const from "../../../util/Constants";
import withRouter from "../../../util/WithRouter";
import Util from "../../../util/Util";
import HeaderViewList from "../../list/HeaderViewList";
import ViewController from "../../../controller/ViewController";
import moment from "moment";
class UserList extends React.Component {
  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters")
      ? JSON.parse(query.get("filters"))
      : null;

    const models = reactLocalStorage.getObject(Const.Model);
    this.model = models.user || {};

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
    this.path = this.props.match.path;
    this.views = ViewController.getViews(Const.UserNo);

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    const defaultView =
      this.views.find((v) => v.id === (filters ? 0 : cView.user || 0)) ||
      this.views[0];

    this.list = reactLocalStorage.getObject(Const.ListUser) || {};
    if (filters) this.list.filters = filters;
    if (!this.list.filters) this.list.filters = [];
    if (!this.list.isFilterOpen) this.list.isFilterOpen = false;
    if (!this.list.pagination)
      this.list.pagination = { currentPage: 1, pageCount: 1, perPage: 10 };

    this.state = {
      inApiCall: true,
      isFilterOpen: this.list.isFilterOpen,
      view: defaultView,
    };

    this.users = [];
  }

  componentDidMount() {
    if (this.List) {
      this.loadUser();
    }
  }

  loadUser = () => {
    if (this.list) {
      const filters = [];

      if (this.Restrict) {
        const user = reactLocalStorage.getObject(Const.LoggedInUser);
        user.child = user.child || [];
        user.child.push(user.user_id);

        filters.push({
          field: "id",
          type: "id",
          condition: "in",
          value: `${Const.Opt}${user.child.join(Const.Opt)}${Const.Opt}`,
        });
      }

      const viewFilter = ViewController.filters(
        [...this.list.filters],
        this.state.view.filters,
        this.Restrict
      );

      UserAPI.list(viewFilter, this.onUserRecived, this.onFail);
    }
  };

  onUserRecived = (users) => {
    this.users = users.data || [];
    this.setState({ inApiCall: false });
  };

  onFail = () => {
    this.setState({ inApiCall: false });
  };

  confirmDeactive = (index) => {
    Util.confirmAlert(
      "Deactivate",
      `Are you sure you want to deactivate ${this.users[index].name}?`,
      "Deactivate",
      "No",
      () => {
        this.setState({ inApiCall: true });
        UserAPI.deactive(this.users[index].id, this.onDeactive, this.onFail);
      }
    );
  };

  onDeactive = () => {
    Util.showNotification(
      "Successful",
      "User Deactivated successfully",
      "success"
    );
    this.loadUser();
  };

  confirmActive = (index) => {
    Util.confirmAlert(
      "Activate",
      `Are you sure you want to activate ${this.users[index].name}?`,
      "Activate",
      "No",
      () => {
        this.setState({ inApiCall: true });
        UserAPI.active(this.users[index].id, this.onActive, this.onFail);
      }
    );
  };

  onActive = () => {
    Util.showNotification(
      "Successful",
      "User Activated successfully",
      "success"
    );
    this.loadUser();
  };

  onTabClick = (viewId) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.user = viewId;
    reactLocalStorage.setObject(Const.CurrentViews, cView);

    const selectedView = this.views.find((item) => item.id === viewId);
    if (selectedView && selectedView.id !== this.state.view.id) {
      this.setState({ view: selectedView, isFilterOpen: false }, this.loadUser);
    }
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListUser, this.list);
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  render() {
    if (!this.List) return null;

    const usersUI = this.users.length ? (
      this.users.map((user, i) => (
        <tr key={`user_${user.id || i}`}>
          <td>{user.id}</td>
          <td>{user.name}</td>
          <td>{user.username}</td>
          <td>{user.work_email}</td>
          <td>{user.work_phone}</td>
          <td>{Display.ModelLabelValue("role", user.role)}</td>
          <td>{Display.FieldValue(user, "reporting", this.model.fields)}</td>
          {this.state.view.id !== 0 && (
            <td>
              {moment(user.deactivated_date).format("DD-MM-YYYY hh:mm A")}
            </td>
          )}
          <td>
            <NavLink
              to={`${this.path}/preview/${user.id}`}
              className="buttons buttons-sm add"
              title="Preview"
            >
              <FaList />
            </NavLink>

            {this.Update && (
              <>
                <NavLink
                  to={`${this.path}/add-edit/${user.id}`}
                  className="buttons update buttons-sm"
                  title="Edit"
                >
                  <FaPencilAlt />
                </NavLink>
                <NavLink
                  to={`${this.path}/email-edit/${user.id}`}
                  className="buttons update buttons-sm"
                  title="Edit Email"
                >
                  <FaEnvelope />
                </NavLink>
              </>
            )}

            {user.status !== Const.AlwaysActive &&
              user.status !== Const.Deactive &&
              this.Delete && (
                <span
                  onClick={() => this.confirmDeactive(i)}
                  className="buttons delete buttons-sm"
                  title="Deactivate"
                >
                  <FaPause /> Deactivate
                </span>
              )}

            {user.status === Const.Deactive && (
              <span
                onClick={() => this.confirmActive(i)}
                className="buttons success buttons-sm"
                title="Activate"
              >
                <FaPlay /> Activate
              </span>
            )}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="9" className="text-center">
          No Records Found
        </td>
      </tr>
    );

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="mb-0">Users</h3>
            {this.Add && (
              <NavLink
                to={`${this.path}/add-edit/0`}
                className="btn btn-success btn-sm"
              >
                + Add User
              </NavLink>
            )}
          </div>
          <hr />
          <div className="mb-3">
            <HeaderViewList
              views={this.views}
              view={this.state.view}
              onTabClick={this.onTabClick}
            />
          </div>

          <div className="table-responsive">
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>No</th>
                  <th>Name</th>
                  <th>Username</th>
                  <th>Email</th>
                  <th>Work Phone</th>
                  <th>Role</th>
                  <th>Reporting</th>
                  {this.state.view.id !== 0 && <th>Deactivate Date</th>}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>{usersUI}</tbody>
            </Table>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(UserList);
